// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { NavLink } from 'react-router-dom';

import '../styles/navigation.css';
import { ADMIN_EMAILS } from '../utilities/staxAdmins';

export default class Navigation extends React.Component {
    showTPA = () => this.props.team?.scopes?.includes('tpa') && this.props.user?.isAdmin
    showDash = () => this.props.team?.ta?.dashboard && this.props.user?.isAdmin 

    links = [
        {
            icon: "home.png", 
            title: "My Stacks", 
            to: "/", 
            show: () => true, 
            children: [], 
        },
        {
            icon: "user.png", 
            title: "Assigned", 
            to: "/stack/mine", 
            show: () => true, 
            children: [], 
        },
        {
            icon: "tpa-plan-icon.png", 
            title: "TPA Plans", 
            to: "/settings/plan-editor", 
            show: () => true,
            force: true,  
            children: [], 
        },
        {
            icon: "investments.png", 
            title: "TPA Assets", 
            to: "/investments", 
            show: () => true, 
            force: true,
            children: [], 
        },
        {
            icon: "archives.png", 
            title: "Archives", 
            to: "/archives", 
            show: () => true, 
            children: [], 
        },
        {
            icon: "trash.png", 
            title: "Trash", 
            to: "/trash", 
            show: () => true, 
            children: [], 
        },
        {
            icon: "filter.png", 
            title: "Filters", 
            to: "/fields", 
            show: () => true, 
            children: [], 
        },
        {
            icon: "settings.png", 
            title: "Settings", 
            to: "/settings/account", 
            show: () => true, 
            force: (() => !window.location.pathname.startsWith("/settings"))(), 
            children: [
                {
                    icon: "user.png", 
                    title: "Account", 
                    to: "/settings/account", 
                    show: () => true, 
                    force: (() => !window.location.pathname.startsWith("/settings"))(), 
                    children: [], 
                },
                {
                    icon: "users.png", 
                    title: "Users", 
                    to: "/settings/team", 
                    show: () => this.props.user?.isAdmin, 
                    force: (() => !window.location.pathname.startsWith("/settings"))(), 
                    children: [], 
                },
                {
                    icon: "email.png", 
                    title: "Email", 
                    to: "/settings/email", 
                    show: () => this.props.user?.isAdmin, 
                    force: (() => !window.location.pathname.startsWith("/settings"))(), 
                    children: [], 
                },
                {
                    icon: "import.png", 
                    title: "Sync Data", 
                    to: "/settings/import", 
                    show: () => this.props.user?.isAdmin, 
                    force: (() => !window.location.pathname.startsWith("/settings"))(), 
                    children: [], 
                },
                {
                    icon: "scripts.png", 
                    title: "Scripts", 
                    to: "/settings/scripts", 
                    show: () => this.props.user?.isAdmin && ADMIN_EMAILS.includes(this.props.user?.email), 
                    force: (() => !window.location.pathname.startsWith("/settings"))(), 
                    children: [], 
                },
                {
                    icon: "billing.png", 
                    title: "Billing", 
                    to: "/settings/billing", 
                    show: () => this.props.user?.isAdmin, 
                    force: (() => !window.location.pathname.startsWith("/settings"))(), 
                    children: [], 
                },
            ], 
        },
    ]

    renderLink = (link, indent) => {
        const { icon, title, to, show, children, force } = link; 

        // Check if this link should be expanded or not 
        if (!show()) return null;  

        const pathName = window.location.pathname;  
        const expaned = [...children?.map(child => child.to)].includes(pathName);  

        return (<>
            <NavLink
                className={'navigation-link hover-gray' + (expaned ? " navigation-active" : "")}
                 // Indent based on the level of the link 
                activeClassName={indent === 0 ? 'navigation-active' : "navigation-child-active"}
                key={to}
                to={to} 
                exact={to === '/'} 
                onClick={() => {
                    if(force) window.location.href = to 
                }}
            >
                <img 
                    src={`https://static.stax.ai/images/nav/${this.props.user && this.props.user.enableDarkMode ? 'dark/' : ''}${icon}`}
                    alt={title}
                />

                {
                    this.props.assigned && this.props.assigned.numDocuments && title === "Assigned" ? 
                    <div className='navigation-link-count'>
                        {this.props.assigned.numDocuments > 99 ? "..." : this.props.assigned.numDocuments}
                    </div>:""
                }

                {
                    this.props.unread && this.props.unread.numDocuments && title === "Unread" ? 
                    <div className='navigation-link-count'>
                        {this.props.unread.numDocuments > 99 ? "..." : this.props.unread.numDocuments}
                    </div>:""
                }

                {title}
                <div style={{ clear: 'both' }} />
            </NavLink>

            {
                expaned && children.length > 0 ? (
                    <>{children.map((child, childIdx) => this.renderLink(child, indent + 1))}</>
                ): null
            }
        </>)
    }


    render = () => {
        return (
            <div
                className='navigation-container'
            >
                <div
                    className='navigation-logo'
                    onClick={() => window.location.href = "/"}
                >
                    <img
                        src="https://static.stax.ai/images/logo/color.svg"
                        alt="[Stax·ai Logo]"
                    />
                    STAX<div className="navigation-logo-dot"></div>AI                     
                </div>

                <div className='navigation-bar'>
                    {
                        this.links.map((link) => {
                            return this.renderLink(link, 0); 
                        })
                    }
                </div>
            </div>
        )
    }
}